import $ from 'jquery';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';

export default function() {
  $(document).trigger('menusWillClose');

  const state = '[data-state]';

  if ($(state).hasClass('State--cart-open') || $(state).hasClass('State--modal-open')) {
    $('[data-pre-header]').css('right', 0);
    $('[data-header]').css('right', 0);

    if ($(state).hasClass('State--modal-open')) {
      $('main, [data-footer]').css('padding-right', 0);
      const modal_id = $('[data-modal].Modal--open').attr('id');
      
      // Remove the hash if it matches
      if (window.location.hash === `#${modal_id}`) {
        window.history.pushState('', document.title, window.location.pathname + window.location.search);
        $(window).trigger('hashchange');
      }
    }
  }

  $('[data-site-overlay]').removeClass('SiteOverlay--active');
  $('[data-search-drawer]').removeClass('SearchDrawer--open');
  $('[data-cart-toggle]').removeClass('IconToggle--open');
  $('[data-search-toggle]').removeClass('IconToggle--open');
  $('[data-modal]').removeClass('Modal--open');

  $(state).removeClass('State--mobile-menu-open');
  $(state).removeClass('State--cart-open');
  $(state).removeClass('State--modal-open');

  $('[data-search-drawer] form input').trigger('blur');
  
  clearAllBodyScrollLocks();

  $(document).trigger('menusDidClose');
}